<template>
  <div class="min-h-screen">
    <WopiFrame v-if="wopiStore.enabled" />
    <div v-show="!wopiStore.iFrameLoaded" class="min-h-screen flex flex-col">
      <div v-if="isStandardRoute" class="grow flex flex-col">
        <AppHeader />
        <InformationBanner class="w-full px-4 shadow-lg" />
        <main
          role="main"
          class="h-0 grow flex flex-col overflow-hidden overflow-y-scroll print:h-auto print:overflow-visible"
          :class="{
            'p-2': currentRouteName.startsWith('admin'),
          }"
        >
          <router-view></router-view>
        </main>
        <Onboarding v-if="authStore.isAuthenticated" />
        <AppFooter />
      </div>
      <main v-else role="main">
        <router-view></router-view>
      </main>
      <div id="modals-holder" class="absolute z-50"></div>
    </div>
    <PAlertHolder />
  </div>
</template>

<script setup lang="ts">
import { PAlertHolder, PastaRouteType, useConfig, usePastaRouter } from "@pasta/box-v2";
import { useAuthStore } from "@pasta/front-auth-v2";
import { InformationBanner } from "@pasta/front-information-banner";
import { useHead } from "@unhead/vue";
import { computed, onMounted } from "vue";
import AppFooter from "./components/app-footer.vue";
import AppHeader from "./components/app-header.vue";
import Onboarding from "./components/Onboarding/Onboarding.vue";
import WopiFrame from "./components/WopiFrame.vue";
import { useWopiStore } from "./stores/wopi.store";
import { type ParapheurConfig } from "./types";

const config = useConfig<ParapheurConfig>();

useHead({
  title: config.headerTitle || "Demo app",
  meta: [{ charset: "utf-8" }],
});

const pastaRouter = usePastaRouter();
const currentRouteName = computed(() => {
  return (pastaRouter.vueRouter.currentRoute.value.name || "").toString().toLowerCase();
});

const isStandardRoute = computed(() => {
  return (
    pastaRouter.getPastaRoutes().find(route => route.name === currentRouteName.value)?.type === PastaRouteType.STANDARD
  );
});

const authStore = useAuthStore();
const wopiStore = useWopiStore();

onMounted(async () => {
  await Notification.requestPermission();
});
</script>
